export const BOTTOM_SHEET_HANDLE_CLASS_NAME =
    "h-1 w-16 rounded-full bg-[#363636]";

export const BOTTOM_SHEET_HANDLE_HIT_AREA_CLASS_NAME =
    "flex justify-center pb-4 pt-5 touch-none select-none";
